const TopicList = ({topicList, selectedTopic, handleSetTopic, source}) => {
    return (
        <div className="menu__content">
        {
          topicList?.map(topic => 
          (
            <div className={`menu__item ${topic.passphrase === selectedTopic ? 'active' : ''} ${source}`} onClick={() => handleSetTopic(topic)}>
              {console.log(topic.passphrase, selectedTopic)}
              <p>{topic.name}</p>
              
            </div>
          ))
        }
        
        
      </div>
    )
}

export default TopicList;